import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const basePath = '/dnfministry';
  
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight - 80,
      behavior: 'smooth'
    });
  };

  return (
    <section 
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: '#1a1a1a'
      }}
    >
      {/* Background with overlay */}
      <div style={{ position: 'absolute', inset: 0 }}>
        {/* Background image */}
        <div 
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url('https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.3) saturate(0.8)'
          }}
        />
        {/* Gradient overlay */}
        <div 
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to bottom, rgba(26,26,26,0.7), transparent, rgba(26,26,26,1))'
          }}
        />
      </div>

      {/* Content */}
      <div 
        style={{
          position: 'relative',
          zIndex: 30,
          textAlign: 'center',
          padding: '0 1rem',
          maxWidth: '56rem',
          margin: '0 auto',
          paddingTop: '5rem'
        }}
      >
        {/* Tagline */}
        <p style={{ color: '#B8860B', letterSpacing: '0.4em', textTransform: 'uppercase', fontSize: '0.875rem', marginBottom: '1.5rem' }} className="animate-fade-in">
          A Timeless Love
        </p>

        {/* Main Headline */}
        <h1 className="font-serif animate-slide-up" style={{ fontSize: 'clamp(2.5rem, 8vw, 4.5rem)', color: '#F5F5DC', marginBottom: '1rem', lineHeight: 1.1 }}>
          The Wedding Celebration
        </h1>
        <h2 className="font-serif animate-slide-up" style={{ fontSize: 'clamp(1.5rem, 5vw, 3rem)', color: 'rgba(245,245,220,0.9)', marginBottom: '2.5rem', lineHeight: 1.2 }}>
          of Two Souls
        </h2>

        {/* Officiant */}
        <p style={{ color: 'rgba(245,245,220,0.6)', letterSpacing: '0.2em', textTransform: 'uppercase', fontSize: '0.75rem', marginBottom: '0.75rem' }} className="animate-fade-in">
          Officiated by
        </p>
        <p className="font-script text-shimmer animate-fade-in" style={{ fontSize: 'clamp(2.5rem, 7vw, 4rem)', marginBottom: '0.75rem' }}>
          Keeper Of The Fiyah
        </p>
        <p style={{ color: '#B8860B', letterSpacing: '0.3em', textTransform: 'uppercase', fontSize: '0.875rem', marginBottom: '3rem' }} className="animate-fade-in">
          Drip N Fiyah Ministry
        </p>

        {/* CTA Buttons */}
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }} className="animate-fade-in">
          <Link
            to={`${basePath}/booking`}
            className="btn-gold"
            style={{ fontSize: '0.875rem', letterSpacing: '0.2em', textTransform: 'uppercase', textDecoration: 'none' }}
            data-testid="hero-book-btn"
          >
            Begin Your Journey
          </Link>
          <Link
            to={`${basePath}/services`}
            className="btn-gold-outline"
            style={{ fontSize: '0.875rem', letterSpacing: '0.2em', textTransform: 'uppercase', textDecoration: 'none' }}
            data-testid="hero-services-btn"
          >
            View Services
          </Link>
        </div>

        {/* Scripture */}
        <div style={{ marginTop: '4rem' }} className="animate-fade-in">
          <p className="font-serif" style={{ color: 'rgba(245,245,220,0.5)', fontStyle: 'italic', fontSize: '0.875rem', maxWidth: '32rem', margin: '0 auto' }}>
            "...He considered me faithful by assigning me to a ministry."
          </p>
          <p style={{ color: 'rgba(184,134,11,0.6)', fontSize: '0.875rem', marginTop: '0.5rem' }}>— 1 Timothy 1:12</p>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToContent}
        style={{
          position: 'absolute',
          bottom: '2rem',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#B8860B',
          zIndex: 30,
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
        className="animate-bounce"
        aria-label="Scroll to content"
        data-testid="scroll-indicator"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
